import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateReportTemplateDto } from '../../dtos/create-report-template.dto';
import { UpdateReportTemplateDto } from '../../dtos/update-report-template.dto';
import { createReportTemplateSchema } from '../schemas/create-report-template.schema';
import { updateReportTemplateSchema } from '../schemas/update-report-template.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateReportTemplateDto | UpdateReportTemplateDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateReportTemplateSchema if 'id' is present
		validationResult = updateReportTemplateSchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createReportTemplateSchema if 'id' is not present
		validationResult = createReportTemplateSchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
